export const HeadCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: true,
        label: 'Order #',
        sort: true,
        type: 'text',
    },
    {
        id: 'order_status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
        sort: true,
        type: 'text',
    },
    {
        id: 'location_name',
        numeric: true,
        disablePadding: false,
        label: 'Store',
        sort: true,
        type: 'text',
    },
    {
        id: 'first_name',
        numeric: true,
        disablePadding: false,
        label: 'Customer',
        sort: true,
        type: 'text',
    },
    {
        id: 'order_total',
        numeric: true,
        disablePadding: false,
        label: 'Total',
        sort: true,
        type: 'text',
        prefix: '$',
    },
    {
        id: 'order_type',
        numeric: true,
        disablePadding: false,
        label: 'Order Type',
        sort: true,
        type: 'text',
    },
    {
        id: 'order_promised_time',
        numeric: true,
        disablePadding: false,
        label: 'Promised Time',
        sort: true,
        type: 'dateTime',
    },
    {
        id: 'order_creation_date',
        numeric: true,
        disablePadding: false,
        label: 'Order Placed',
        sort: true,
        type: 'dateTime',
    },
];
export const BodyCells = [
    {
        id: 'id',
    },
    {
        id: 'order_status',
        background: 'orders',
    },
    {
        id: 'location_name',
    },
    {
        id: 'first_name',
    },
    {
        id: 'order_total',
        prefix: '$',
    },
    {
        id: 'order_type',
    },
    {
        id: 'order_promised_time',
    },
    {
        id: 'order_creation_date',
    },
];
export const dataFields = [
    'id',
    'order_status',
    'location_name',
    'first_name',
    'order_total',
    'order_type',
    'order_promised_time',
    'order_creation_date',
];
